import { getPdfsimpliEndPoint, endPoints } from "./api-constants";
import { getAuthHeader, readCookie } from "../utils/helpers";
import { apiService } from "../services/base-api-service";

class PdfSimpliController {
  PdfSimpli(url) {
    return getPdfsimpliEndPoint(url);
  }
  addWizard(data) {
    const getDocumentProfileEndPoint = this.PdfSimpli(`${endPoints.pdfsimpliController.ADD_WIZARD}`);
    return apiService.post(getDocumentProfileEndPoint, data, getAuthHeader());
  }
}
export default new PdfSimpliController();
